/**
 * Reducers index script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as formReducer } from 'redux-form';

import general from './generalReducer';
import translation from './translationReducer';
import auth from './authReducer';
import login from './loginReducer';
import recoverPassword from './recoverPasswordReducer';
import resetPassword from './resetPasswordReducer';
import userData from './userDataReducer';
import registration from './registrationReducer';
import userList from './userListReducer';
import userRolesList from './userRolesListReducer';
import userRolesHistoryList from './userRolesHistoryListReducer';
import userListAutocomplete from './userListAutocompleteReducer';
import userListRoles from './userListRolesReducer';
import journalsList from './journalsListReducer';
import journalsListAutocomplete from './journalsListAutocompleteReducer';
import journalData from './journalDataReducer';
import submissionData from './submissionDataReducer';
import journalsAutocomplete from './journalsAutocompleteReducer';
import submissionsList from './submissionsListReducer';
import submissionsListAutocomplete from './submissionsListAutocompleteReducer';
import profilesAutocomplete from './profilesAutocompleteReducer';
import submissionStatuses from './submissionStatusesReducer';
import submissionPhases from './submissionPhasesReducer';
import submissionsCount from './submissionsCountReducer';
import emailsList from './emailsListReducer';
import emailTemplate from './emailTemplateReducer';
import loginSocial from './loginSocialReducer';
import submissionActivities from './submissionActivitiesReducer';
import submissionAttachments from './submissionAttachmentsReducer';
import mailTemplateList from './mailTemplateListReducer';
import mailTemplateData from './mailTemplateDataReducer';
import interestsList from './interestsListReducer';
import interestsAutocomplete from './interestsAutocompleteReducer';
import interestsData from './interestsDataReducer';
import invitationList from './invitationListReducer';
import invitationNameAutocomplete from './invitationNameAutocompleteReducer';
import submissionReviewersList from './submissionReviewersListReducer';
import notificationsList from './notificationsListReducer';
import notificationsData from './notificationsDataReducer';
import settingsData from './settingsDataReducer';
import settingsList from './settingsListReducer';

const rootReducer = combineReducers({
    routing: routerReducer,
    toastr: toastrReducer,
    form: formReducer,
    general,
    translation,
    auth,
    login,
    recoverPassword,
    resetPassword,
    userData,
    registration,
    userList,
    userRolesList,
    userRolesHistoryList,
    userListAutocomplete,
    journalsList,
    journalsListAutocomplete,
    journalData,
    submissionData,
    journalsAutocomplete,
    submissionsList,
    submissionsListAutocomplete,
    userListRoles,
    profilesAutocomplete,
    submissionStatuses,
    submissionPhases,
    submissionsCount,
    loginSocial,
    emailsList,
    emailTemplate,
    submissionActivities,
    submissionAttachments,
    mailTemplateList,
    mailTemplateData,
    interestsList,
    interestsAutocomplete,
    interestsData,
    invitationList,
    invitationNameAutocomplete,
    submissionReviewersList,
    notificationsList,
    notificationsData,
    settingsData,
    settingsList,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js